import { Camera, UnifiedAlarm } from '@hakimo-ui/hakimo/types';
import { createContext, useContext } from 'react';
import { CameraAlarmTracker, CameraDetails } from '../../types';

export interface AlarmGroupCameraContextType {
  /**
   * These camera Ids are those which resides in current show window
   */
  showCameraIds: Set<string>;
  /**
   * Set of camera ids which are currently preloaded
   */
  preloadCameraIds: Set<string>;
  /**
   * Map of camera id to camera details
   */
  camToDetailsMap: Record<string, CameraDetails>;
  /**
   * Map of camera id to alarm tracker
   * currentAlarmId: The current alarm id being shown
   * showAlarmIds: Set of alarm ids which are currently shown for the camera
   * preloadAlarmIds: Set of alarm ids which are currently preloaded for the camera
   * isCamShownCurrently: Whether the camera is currently shown in UI or not
   */
  camToAlarmTracker: Map<string, CameraAlarmTracker>;
  /**
   * Map of extra camera id to camera details. Extra cameras are those which are added for live view
   */
  extraCamDetailsMap: Record<string, CameraDetails>;
  /**
   * Update the extra camera details from the tenant. Extra cameras are those which are added for live view
   */
  updateExtraCamFromTenant: (cams: Camera[]) => void;
  /**
   * Map of alarm id to alarm details
   */
  alarmToDetailsMap: Record<string, UnifiedAlarm>;
}

export const AlarmGroupCameraContext =
  createContext<AlarmGroupCameraContextType>({
    showCameraIds: new Set(),
    preloadCameraIds: new Set(),
    camToDetailsMap: {},
    camToAlarmTracker: new Map(),
    extraCamDetailsMap: {},
    updateExtraCamFromTenant: () => ({}),
    alarmToDetailsMap: {},
  });

export const useAlarmGroupCamera = () => useContext(AlarmGroupCameraContext);
